// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Scalars = require("../../scalars/Scalars.bs.js");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let AvatarSrcUrl = require("../../utils/AvatarSrcUrl.bs.js");
let Avatar__Jsx3 = require("../../uikit/reason/atoms/Avatar/Avatar__Jsx3.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let SharedPropertySidecard_agent_graphql = require("../../__generated__/SharedPropertySidecard_agent_graphql.bs.js");

let convertFragment = SharedPropertySidecard_agent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, SharedPropertySidecard_agent_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(SharedPropertySidecard_agent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, SharedPropertySidecard_agent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(SharedPropertySidecard_agent_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function SharedPropertySidecard(props) {
  let sender = RescriptRelay_Fragment.useFragment(SharedPropertySidecard_agent_graphql.node, convertFragment, props.agent);
  let profilePhoto = sender.profilePhoto;
  let displayName = sender.displayName;
  let avatar = profilePhoto !== undefined ? profilePhoto.sidecardUrl : AvatarSrcUrl.place_holder;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: "Contact your agent to learn more about this property",
        className: "text-center text-gray-700 font-medium text-lg"
      }),
      JsxRuntime.jsx(Avatar__Jsx3.make, {
        src: avatar,
        name: `Avatar for ` + displayName,
        size: "medium"
      }),
      JsxRuntime.jsx("a", {
        children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
          children: JsxRuntime.jsx("div", {
            children: `Contact ` + displayName
          })
        }),
        href: "mailto:" + Scalars.EmailAddress.toString(sender.emailAddress)
      })
    ],
    className: "border border-gray-200 rounded-md bg-white  sticky top-16 max-w-sm\n  flex flex-col items-center p-5 gap-4\n  "
  });
}

let make = SharedPropertySidecard;

exports.Fragment = Fragment;
exports.make = make;
/* Scalars Not a pure module */
